import script from "./ClassicSetPasswordStep.vue?vue&type=script&setup=true&lang=js"
export * from "./ClassicSetPasswordStep.vue?vue&type=script&setup=true&lang=js"

import "./ClassicSetPasswordStep.vue?vue&type=style&index=0&id=674622d4&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-674622d4"]])

export default __exports__